import { HashRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import './MobileApp.css';
import '../src/css/Leader.css'
import Header from './components/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.min.js";
import Learning from './components/learning/Learning';
import AboutUs from './components/about_us/AboutUs';
import Main from './components/generate_keys/Main';
import Footer from './components/Footer';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { createTheme, ThemeProvider } from "@mui/material";
import { faIR } from '@mui/x-date-pickers/locales';
import LoginAdmin from './components/admin-portal/LoginAdmin'
import AdminPortal from './components/admin-portal/AdminPortal';
import MainLoginPage from "./components/generate_keys/login/MainLoginPage";
import CompanyList from "./components/generate_keys/CompanyList";
import FillInfoSuccessPage from "./components/generate_keys/FillInfoSuccessPage";
import UploadDocs from "./components/generate_keys/UploadDocs";
import ErrorComponent from "./components/ErrorComponent";
import { useEffect, useState } from "react";
import PortalLeader from "./components/leader_portal/PortalLeader";
import LeaderLogin from "./components/leader_portal/LeaderLogin";
import { AuthenticatedAdminRoute, AuthenticatedLeaderRoute, AuthenticatedRoute } from "./Auth";
import LandingPage from './components/generate_keys/select_type/LandingPage';

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});
const theme = createTheme({
    components: {
        MuiStep: {
            styleOverrides: {
                root: {
                    direction: "ltr"
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    borderRadius: "10px",
                    border: "1.5px solid #D3D3D3 !important",
                    "& > fieldset": {
                        border: "none"
                    },
                    "&:hover": {
                        border: "1px solid #0BA9B5 !important",
                        boxShadow: "0 0 0 4px #EAFDFF , 0 1px 2px 0 #1018280D",
                        "& > fieldset": {
                            border: "none"
                        }
                    }
                }
            }
        }
    },
    direction: 'rtl',

}, faIR);

function App() {
    const location = useLocation();
    const { hash, pathname, search } = location;
    const [show, setShow] = useState(true);

    useEffect(() => {

        if (pathname.startsWith('/leader')) {
            setShow(false)
        } else {
            setShow(true);
        }
    }, [pathname])


    return (
        <>
            <div className={`${show ? 'border-main' : 'leader_main'}`}>
                <ThemeProvider theme={theme}>
                    <CacheProvider value={cacheRtl}>

                        {show && <Header />}
                        <Routes>

                            <Route exact path="/" element={<LandingPage />} />


                            <Route exact path="/fill-done" element={
                                <AuthenticatedRoute>
                                    <FillInfoSuccessPage />
                                </AuthenticatedRoute>
                            } />


                            <Route exact path="/fill-user-info" element={
                                <AuthenticatedRoute>
                                    <UploadDocs />
                                </AuthenticatedRoute>
                            } />

                            <Route exact path="/login" element={<MainLoginPage />} />

                            <Route path="/company/list" element={
                                <AuthenticatedRoute>
                                    <CompanyList />
                                </AuthenticatedRoute>
                            }></Route>

                            <Route path="/main" element={
                                <AuthenticatedRoute>
                                    <Main />
                                </AuthenticatedRoute>
                            }></Route>

                            <Route path="/learning" element={<Learning />} />
                            <Route path="/about-us" element={<AboutUs />} />

                            <Route path="/admin/login" element={<LoginAdmin />} />
                            <Route path="/admin/portal" element={
                                <AuthenticatedAdminRoute>
                                    <AdminPortal />
                                </AuthenticatedAdminRoute>
                            }></Route>

                            <Route path={'/leader/login'} element={<LeaderLogin />}></Route>
                            <Route path={'/leader/main'} element={
                                <AuthenticatedLeaderRoute >
                                    <PortalLeader />
                                </AuthenticatedLeaderRoute>
                            }></Route>
                            <Route path='*' element={<ErrorComponent />}></Route>
                        </Routes>

                    </CacheProvider>
                </ThemeProvider>
            </div>
            {show && <Footer />}

        </>


    );
}

export default App;
